export const DEFAULT_DATAS_PAGE = {
  'b2bbookingcontext': '',
  'category': '',
  'clienttype': 'B2C',
  'countrycurrencycode': '',
  'hotelcurrencycode': '',
  'hotelbrandcode': '',
  'hotelbrandname': '',
  'hotelcitycode': '',
  'hotelcityname': '',
  'hotelcode': '',
  'hotelcountrycode': '',
  'hotelcountryname': '',
  'hotelgssrating': '',
  'hotelname': '',
  'hoteltripadvisorrating': '',
  'mainstepindicator': 0,
  'offercode': '',
  'pagetype': '',
  'partnerdeduplication': 0,
  'partners_name': '',
  'partners_type': '',
  'roomcode': '',
  'searchcriteriaarrivaldate': '',
  'searchcriteriacitycode': '',
  'searchcriteriacityname': '',
  'searchcriteriacountrycode': '',
  'searchcriteriacountryname': '',
  'searchcriteriadeparturedate': '',
  'searchcriteriadestination': '',
  'searchcriteriahotelratingclass': '',
  'searchcriteriauseb2bcode': false,
  'searchresultsdetails': [],
  'sub_category_level1': '',
  'sub_category_level2': '',
  'sub_category_level3': '',
  'sub_category_level4': '',
  'transactionId': '',
  'ui_snu': '',
  'virtual_page_path': ''
};

export const DEFAULT_USER_DATA = {
  userId: '',
  uilogged: false,
  uicity: '',
  uicountry: '',
  uiallmember: 'not logged',
  uiloyaltypoints: '',
  newsletteroptin: false,
  clienttype: 'B2C',
  uiemailsha256: '',
  loyaltycardtypes: '',
  uisnu_activation: 'not connected',
  uistayplus_activation: 'not connected'
};

export const DEFAULT_DATAS_EVENT = {
  'event': 'GAevent',
  'eventAction': '',
  'eventCategory': '',
  'eventLabel': ''
};

export const ORM_COOKIE_NAME = 'ORM_ALL';
export const SUFFIX_ORM_LOGIN_EVENT = '_LOGIN';

export const DATA_PAGENAME = 'data-pagename';
export const DATA_NOPUSH = 'data-nopush';

export const TRAFFIC_SOURCE_LOCAL_STORAGE_KEY = 'TS_AH';
export const TRAFFIC_SOURCE_COOKIE_NAME = 'trckCookie';
export const EMPTY_VAL = '';

export const GACID_COOKIE_NAME = 'gacid';
export const GACID_COOKIE_DOMAIN = '.accor.com';
export const GACID_OUTSIDE_CLIENT = 'outside-client';

export const PARTNERS_ID_LIST = {
  'partner_id': null,
  'hmGUID': /[a-zA-Z0-9]{22}/gm,
  'qt_tracking_id': null,
  'advertiser_id': /[0-9]*/gm,
  'trvReference': /[0-9a-f]{8}[0-9a-f]{4}[0-5][0-9a-f]{3}[089ab][0-9a-f]{3}[0-9a-f]{12}/gm,
  'locale': /[A-Z]{2}/gm,
  'refId': /[a-zA-Z0-9-]{36}/gm,
  'kayakclickid': /[a-zA-Z0-9-_$~=]{100}/gm
};

const DEBUG_MODE = false;

export const  logger = (a,b) => { DEBUG_MODE && console.log(a, b || "");};